<template>
  <div class="w-full flex flex-col justify-center relative">
    <!--    <div v-if="showCode" class="absolute h-full cursor-pointer" @click="showCode = !showCode">-->
    <!--      <div class=" w-full h-full bg-black opacity-75">-->
    <!--      </div>-->
    <!--      <div class="flex absolute flex justify-center pt-40 top-0 w-full">-->
    <!--        <img :src="user.qr_code" alt="user">-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="h-64 w-64 rounded-full self-center bg-black absolute">-->
    <!--      <img :src="image" alt="user" class=" rounded-full">-->
    <!--    </div>-->
    <div class="bg-white w-full h-64 rounded-t-lg bg-blue-100 shadow-lg">
      <div class="flex justify-end py-2">
        <div class="p-3 rounded-lg cursor-pointer  text-left pl-4 text-txt-primary mb-1 mx-3"
             style="background: linear-gradient(75deg, #F4BE19 0%, #f4cf6d 100%);"
             @click="showCode=true">
          Show Bar Code
        </div>
      </div>
    </div>
    <!--    <div class="bg-white pt-32 w-full px-16 h-64 rounded-b-lg shadow-lg">-->
    <!--      <div class="w-full text-txt-primary text-left capitalize">-->
    <!--        <p> Name : {{ user.name }}</p>-->
    <!--        <p> Vendor : {{ user.profile.vendor }}</p>-->
    <!--        <p> Address : {{ user.profile.address }}.</p>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Profile',
  data: () => ({
    showCode: false
    // image: require('../../assets/images/user.jpg')
  }),
  computed: {
    ...mapGetters({
      user: 'user/user_info'
    })
  },
  mounted: {},
  beforeRouteEnter (to, from, next) {
    const show = !!(to.params.showBarCode)
    if (show) {
      next(vm => {
        vm.showCode = show
      })
    } else {
      next()
    }

  }
}
</script>

<style scoped>

</style>
